import { Btn } from "../../../AbstractElements";
import React, { Fragment, useState, useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Col, Form, Label, InputGroup, InputGroupText, Row } from "reactstrap";
import { H5, H4, H6, Image } from "../../../AbstractElements";
import { toast } from "react-toastify";
import { SignUp, SignIn } from "../../../Constant";
import {
  signUp,
  getCurrentUser,
  confirmSignIn,
  confirmSignUp,
  resendSignUpCode,
  signOut,
  fetchAuthSession,
} from "aws-amplify/auth";
import AWS from "aws-sdk";
import { ASSET_OWNER_FOLDER, S3_BUCKET, REGION } from "../../../Config/Config";
import Autocomplete from "react-google-autocomplete";
import { generateClient } from "aws-amplify/api";
const client = generateClient({
  headers: {
    "x-api-key": "da2-ox6gomta4baghjuzk6hpogw25y",
  },
});

const Aosp = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors, touchedFields },
    e,
    reset,
    getValues,
    watch,
    trigger,
  } = useForm({ mode: "onChange" });
  const [ProfilePic, setProfilePic] = useState("");
  AWS.config.update({
    accessKeyId: process.env.REACT_APP_ACCESSKEYID,
    secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY,
  });
  const myBucket = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
  });
  const [sendingCode, setSendingCode] = useState(false);
  const [signupUsername, setSignupUsername] = useState("");
  const [registeredUserId, setRegisteredUserId] = useState("");
  const [companyAdress, setCompanyAdress] = useState("");
  const [siteAdressArray, setsiteAdressArray] = useState([]);
  const [addressError, setAddressError] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [codeSent, setCodeSent] = useState(false);
  const [verificationCode, setVerificationCode] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);
  const [isCodeVerified, setIsCodeVerified] = useState(false);
  const [passwordTouched, setPasswordTouched] = useState(false);
  const passwordValue = watch("password", "");
  const passwordRules = {
    length: passwordValue.length >= 8,
    number: /[0-9]/.test(passwordValue),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(passwordValue),
    capital: /[A-Z]/.test(passwordValue),
  };
  console.log("passwordRules", passwordRules);

  useEffect(() => {
    console.log(props);
  }, []);

  const onPlaceChanged = (detailAddress) => {
    console.log(detailAddress);
    let fullAddress1 = [];
    for (let i = 0; i < detailAddress.length; i++) {
      if (detailAddress[i].types.includes("postal_code")) {
        fullAddress1["postcode"] = detailAddress[i].long_name;
      }
      if (detailAddress[i].types.includes("locality")) {
        fullAddress1["suburb"] = detailAddress[i].long_name;
      }
      if (detailAddress[i].types.includes("administrative_area_level_1")) {
        fullAddress1["state"] = detailAddress[i].long_name;
      }
      if (detailAddress[i].types.includes("administrative_area_level_2")) {
        fullAddress1["street"] = detailAddress[i].long_name;
      }
      if (detailAddress[i].types.includes("country")) {
        fullAddress1["country"] = detailAddress[i].long_name;
      }
    }
    console.log(fullAddress1);
    setsiteAdressArray(fullAddress1);
  };

  const sendVerificationCode = async () => {
    if (sendingCode) return;

    try {
      setSendingCode(true);

      const fullname = getValues("fullname");
      const email = getValues("owneremail");
      const password = getValues("password");

      if (!fullname || !email || !password) {
        toast.error("Please enter Full Name, Email and Password", {
          position: toast.POSITION.TOP_CENTER,
        });
        return;
      }

      const username =
        fullname.toLowerCase().replace(/[^a-z0-9]/gi, "") +
        Math.floor(Math.random() * 1000);

      const { userId } = await signUp({
        username,
        password,
        options: {
          userAttributes: {
            email,
            name: fullname,
            "custom:userType": "spao",
          },
        },
      });

      setRegisteredUserId(userId);
      setSignupUsername(username);
      setEmailSent(true);

      toast.success("Verification code sent successfully!", {
        position: toast.POSITION.TOP_CENTER,
      });
      setCodeSent(true);
    } catch (error) {
      console.error(error);

      if (error.name === "UsernameExistsException") {
        toast.error("User already exists. Try different name.", {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        toast.error(error.message || "Error sending verification code", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } finally {
      setSendingCode(false); //  ALWAYS reset
    }
  };

  // const handleVerificationChange = (e, index) => {
  //   console.log("ee", e.target.value);
  //   console.log("verificationCode", verificationCode);

  //   const value = e.target.value;

  //   if (!/^[0-9]?$/.test(value)) return;

  //   const updatedCode = [...verificationCode];
  //   updatedCode[index] = value;
  //   console.log("updatedCode", updatedCode);

  //   setVerificationCode(updatedCode);

  //   // AUTO VERIFY
  //   if (updatedCode.join("").length === 6) {
  //     console.log("updatedCode.join()", updatedCode.join(""));
  //     verifyCode(updatedCode.join(""));
  //     setIsCodeVerified(true);
  //   } else {
  //     setIsCodeVerified(false);
  //   }
  // };

  const handleVerificationChange = (e, index) => {
    const value = e.target.value;

    if (!/^[0-9]?$/.test(value)) return;

    const updatedCode = [...verificationCode];
    updatedCode[index] = value;
    setVerificationCode(updatedCode);

    // ❗ reset verification when editing
    setIsCodeVerified(false);

    if (value && e.target.nextSibling) {
      e.target.nextSibling.focus();
    }

    if (updatedCode.join("").length === 6) {
      verifyCode(updatedCode.join(""));
    }
  };

  const verifyCode = async (code) => {
    try {
      await confirmSignUp({
        username: signupUsername, //  sanitized one
        confirmationCode: code,
      });

      setIsCodeVerified(true);

      toast.success("Account verified successfully!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } catch (error) {
      console.error(error);
      toast.error(error.message || "Invalid verification code", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const onSubmit = async (data) => {
    console.log(props);
    try {
      // client.graphql({
      // query: mutations.createAssetOwner,
      // variables: {
      // input: {
      // id: props.values.UserId,
      //   firstName: data.firstname,
      // lastName: data.lastname,
      // email: props.values.Email,
      // mobile: data.ownermobilenumber,
      // companydetailsID: props.values.CompanyId,
      //companyName: props.values.CompanyName,
      // profilePicture: ProfilePic,
      // status: "Active",
      // },
      //},
      //authMode: "API_KEY",
      // })
      // .then((result) => {
      //    console.log(result);
      props.values.FirstName = data.fullname;
      props.values.UserId = registeredUserId;
      props.values.Username = signupUsername;
      props.values.LastName = data.lastname;
      props.values.MObileAssetOwner = data.mobilenumber;
      props.values.Aomail = data.owneremail;
      props.values.aoPic = ProfilePic;
      props.values.splicence = data.licensenumber;
      props.values.CompanyAddress = companyAdress;
      props.values.CompanyName = data.companyName;
      props.values.BusinessNumber = data.mobilenumber;
      props.values.password = data.password;
      //   props.values.AssetOwnerId = props.values.UserId;
      //   client.graphql({
      //     query: mutations.updateUserDetails,
      //    variables: {
      //      input: {
      //        id: props.values.UserId,
      //       assetOwnerId: props.values.UserId,
      //     },
      //  },
      //  authMode: "API_KEY",
      // })
      //  .then((userUpdate) => {
      //     console.log(userUpdate);
      //  })
      //  .catch((error) => {
      //   console.log(error);
      // });
      props.nextStep();
      //toast.success(" Created successfully.", {
      //   position: toast.POSITION.TOP_CENTER,
      //  });
      // })
      // .catch((error) => {
      //   console.log(error);
      // toast.error(" Error while Creating ", {
      //    position: toast.POSITION.TOP_CENTER,
      //  });
      // });
    } catch (err) {
      console.log(err);
    }
  };

  //--------------------------------------------------------------------------------------
  const onSelectFile = (e) => {
    const file = e.target.files[0];
    const params = {
      ACL: "public-read",
      Body: file,
      Bucket: S3_BUCKET,
      Key: `public/${ASSET_OWNER_FOLDER}/${file.name}`,
    };
    myBucket
      .putObject(params)
      .on("httpUploadProgress", (evt) => {
        const filedetails = [];
        filedetails.push({ fileName: file.name, type: file.type });
        console.log(filedetails[0].fileName);
        setProfilePic(JSON.stringify(filedetails));
      })
      .send((err) => {
        if (err) console.log(err);
      });
  };

  const getColor = (valid) => {
    if (!passwordTouched) return "#6b7280"; // neutral gray
    return valid ? "#16a34a" : "#dc2626";
  };

  return (
    <Fragment>
      <div className="text-center mb-4">
        <H4>Create your account</H4>
        <p
          style={{
            color: "#6b7280",
            fontSize: "11px",
          }}
        >
          Let’s get your account set up.
        </p>
      </div>
      <div
        className="card border-0 shadow-lg "
        style={{
          width: "100%",
          borderRadius: "24px",
          overflow: "hidden",
        }}
      >
        <div className="p-3">
          <Form
            className="needs-validation"
            noValidate
            onSubmit={handleSubmit(onSubmit)}
          >
            {/* FULL NAME */}
            <Row>
              <Col md="12">
                <Label className="fw-semibold">Full Name</Label>

                <input
                  className="form-control form-control-lg"
                  name="fullname"
                  type="text"
                  placeholder="Full Name"
                  {...register("fullname", {
                    required: true,
                  })}
                  style={{
                    borderRadius: "12px",
                    height: "30px",
                  }}
                />

                <span className="text-danger small">
                  {errors.fullname && "Full Name is required"}
                </span>
              </Col>
            </Row>

            {/* EMAIL */}
            <Row>
              <Col md="12">
                <Label className="fw-semibold">Work Email</Label>

                <input
                  className="form-control form-control-lg"
                  name="owneremail"
                  type="email"
                  placeholder="Email"
                  {...register("owneremail", {
                    required: true,
                  })}
                  style={{
                    borderRadius: "12px",
                    height: "30px",
                  }}
                />

                <span className="text-danger small">
                  {errors.owneremail && "E-mail Address is required"}
                </span>

                {emailSent && (
                  <div
                    className="mt-2"
                    style={{
                      color: "#16a34a",
                      fontSize: "13px",
                      fontWeight: 500,
                    }}
                  >
                    We’ve sent a 6-digit verification code to this email
                  </div>
                )}
              </Col>
            </Row>

            {/* PASSWORD */}
            <Row>
              <Col md="12">
                <Label className="fw-semibold">Password</Label>

                <div className="d-flex gap-2">
                  <input
                    className="form-control form-control-lg"
                    name="password"
                    type="password"
                    placeholder="Enter Password"
                    {...register("password", {
                      required: "Password is required",
                      validate: {
                        length: (v) =>
                          v.length >= 8 || "Must be at least 8 characters",
                        number: (v) =>
                          /[0-9]/.test(v) || "Must include a number",
                        special: (v) =>
                          /[!@#$%^&*(),.?":{}|<>]/.test(v) ||
                          "Must include a special character",
                        capital: (v) =>
                          /[A-Z]/.test(v) || "Must include a capital letter",
                      },
                    })}
                    onChange={() => setPasswordTouched(true)}
                    style={{
                      borderRadius: "12px",
                      height: "30px",
                    }}
                  />
                  {/* <button
                    type="button"
                    className="btn btn-success"
                    disabled={sendingCode}
                    onClick={async () => {
                      const valid = await trigger("password");
                      if (!valid) return;
                      sendVerificationCode();
                    }}
                  >
                    {sendingCode ? "Sending..." : "Send Code"}
                  </button> */}
                  <button
                    type="button"
                    className="btn btn-success"
                    disabled={sendingCode}
                    onClick={async () => {
                      const valid = await trigger("password");
                      if (!valid) return;
                      sendVerificationCode();
                    }}
                  >
                    {sendingCode
                      ? "Sending..."
                      : codeSent
                        ? "Resend Code"
                        : "Send Code"}
                  </button>
                </div>

                {passwordTouched && errors.password && (
                  <span className="text-danger small">
                    {errors.password.message}
                  </span>
                )}

                <div
                  className="d-flex flex-wrap gap-3 mt-2"
                  style={{ fontSize: "13px" }}
                >
                  <span style={{ color: getColor(passwordRules.length) }}>
                    ✔ 8+ characters
                  </span>

                  <span style={{ color: getColor(passwordRules.number) }}>
                    ✔ 1 number
                  </span>

                  <span style={{ color: getColor(passwordRules.special) }}>
                    ✔ 1 special character
                  </span>

                  <span style={{ color: getColor(passwordRules.capital) }}>
                    ✔ 1 capital letter
                  </span>
                </div>
              </Col>
            </Row>

            {/* VERIFICATION CODE */}
            {emailSent && (
              <Row>
                <Col md="12">
                  <Label className="fw-semibold mb-3">Verification Code</Label>

                  <div className="d-flex gap-2 justify-content-between">
                    {[0, 1, 2, 3, 4, 5].map((item, index) => (
                      <input
                        key={index}
                        type="text"
                        maxLength="1"
                        className="form-control text-center"
                        value={verificationCode[index] || ""}
                        onChange={(e) => handleVerificationChange(e, index)}
                        style={{
                          width: "55px",
                          height: "55px",
                          borderRadius: "12px",
                          fontSize: "20px",
                          fontWeight: "600",
                        }}
                      />
                    ))}
                  </div>

                  {isCodeVerified && (
                    <div
                      className="mt-2"
                      style={{
                        color: "#16a34a",
                        fontSize: "13px",
                        fontWeight: 500,
                      }}
                    >
                      Code verified successfully ✔
                    </div>
                  )}
                </Col>
              </Row>
            )}

            {isCodeVerified && (
              <>
                {/* MOBILE NUMBER */}
                <Row>
                  <Col md="12">
                    <Label className="fw-semibold">Mobile Number</Label>

                    <input
                      className="form-control form-control-lg"
                      name="mobilenumber"
                      type="number"
                      placeholder="0412 345 678"
                      {...register("mobilenumber", { required: true })}
                      style={{ borderRadius: "12px", height: "30px" }}
                    />

                    <span className="text-danger small">
                      {errors.mobilenumber && "Mobile Number is required"}
                    </span>
                  </Col>
                </Row>

                {/* ROLE */}
                <Row>
                  <Col md="12">
                    <Label className="fw-semibold">I am a...</Label>

                    <select
                      className="form-select form-select-lg"
                      {...register("userrole", { required: true })}
                      defaultValue=""
                      style={{ borderRadius: "3px", height: "35px" }}
                    >
                      <option value="">Select Role</option>
                      <option value="Electrical Contractor (Asset Owner and Service Provider)">
                        Electrical Contractor (Asset Owner and Service Provider)
                      </option>
                    </select>

                    <span className="text-danger small">
                      {errors.userrole && "Please select a role"}
                    </span>
                  </Col>
                </Row>

                {/* LICENSE */}
                <Row>
                  <Col md="12">
                    <Label className="fw-semibold">
                      Electrical Licence Number
                    </Label>

                    <input
                      className="form-control form-control-lg"
                      {...register("licencenumber", { required: true })}
                      type="text"
                      placeholder="Electrical Licence Number"
                      style={{ borderRadius: "12px", height: "30px" }}
                    />

                    <span className="text-danger small">
                      {errors.licencenumber && "Licence Number is required"}
                    </span>
                  </Col>
                </Row>

                {/* COMPANY NAME */}
                <Row>
                  <Col md="12">
                    <Label className="fw-semibold">Company Name</Label>

                    <input
                      className="form-control form-control-lg"
                      {...register("companyName", { required: true })}
                      type="text"
                      placeholder="Company Name"
                      style={{ borderRadius: "12px", height: "30px" }}
                    />

                    <span className="text-danger small">
                      {errors.companyName && "Company Name is required"}
                    </span>
                  </Col>
                </Row>

                {/* COMPANY ADDRESS */}
                <Row>
                  <Col md="12">
                    <Label className="fw-semibold">Company Address</Label>

                    {/* <input
                      className="form-control form-control-lg"
                      {...register("companyAddress", { required: true })}
                      type="text"
                      placeholder="Company Address"
                      style={{ borderRadius: "12px", height: "30px" }}
                    /> */}
                    <Autocomplete
                      apiKey="AIzaSyBTumeD-l8p-2slpOP7PEJ7KKOlaFfOOj4"
                      className="form-control"
                      onPlaceSelected={(place) => {
                        console.log(place);
                        setCompanyAdress(place.formatted_address);
                        const address = place.address_components;
                        onPlaceChanged(address);
                        if (place) {
                          setAddressError(false);
                        } else {
                          setAddressError(true);
                        }
                      }}
                      options={{
                        types: ["address"],
                        componentRestrictions: { country: "AU" },
                      }}
                      name="companyAddress"
                      placeholder="Company Address"
                      //defaultValue={props.values.CompanyAddress}
                    />

                    <span className="text-danger small">
                      {errors.companyAddress && "Company Address is required"}
                    </span>
                  </Col>
                </Row>

                {/* SUBMIT */}
                <div className="mt-4">
                  <Btn
                    attrBtn={{
                      color: "success",
                      className: "w-100",
                      style: {
                        height: "30px",
                        borderRadius: "12px",
                        fontWeight: "600",
                        fontSize: "16px",
                      },
                    }}
                  >
                    Create Account
                  </Btn>
                </div>
              </>
            )}

            {/* TERMS */}
            <div
              className="text-center mt-4"
              style={{
                fontSize: "13px",
                color: "#6b7280",
              }}
            >
              By creating an account, you agree to our Terms of Service and
              Privacy Policy.
            </div>
          </Form>
        </div>
      </div>
    </Fragment>
  );
};

export default Aosp;
